import { createFileRoute } from "@tanstack/react-router";
import { Data } from "@/features/settings/data";

export const Route = createFileRoute("/settings/data")({
  component: Data,
});
